import apiFetch from '@scale/frontend-lib/api-fetch';
import { SpeedAuditResult, SubtaskAssignment } from './types';
import { PerAnnotationError } from '@scale/shared/types/customerAudit';
import { SpeedAuditVersion } from '@scale/shared/defaults';
import { PartialRecord } from '@scale/shared/types/utils';

export const updateAttemptAudit = async ({
  attemptAuditId,
  result,
  flagResult,
  comments,
  taskInstructionItems,
  perAnnotationInstructionItems,
}: {
  attemptAuditId: string;
  result?: string;
  flagResult?: string;
  comments?: string;
  taskInstructionItems?: string[];
  perAnnotationInstructionItems?: PerAnnotationError[];
}) => {
  await apiFetch(null, `corp-api/attemptAudit/attemptAudits/${attemptAuditId}`, {
    method: 'POST',
    body: {
      result,
      flagResult,
      comments,
      taskInstructionItems,
      perAnnotationInstructionItems,
    },
  });
  return attemptAuditId;
};

export function getInitialResult(response: SubtaskAssignment) {
  const emptyResult: SpeedAuditResult = {
    objectId: response.auditLookup.id,
    objectType: response.auditLookup.type,
    attemptAuditId: response.attemptAuditId!,
    result: response.result,
    resultV2: response.resultV2,
    flagResult: response.flagResult,
    comments: response.comments,
    taskInstructionItems: response.taskInstructionItems,
    perAnnotationInstructionItems: response.perAnnotationInstructionItems,
  };
  return emptyResult;
}

export function speedAuditEventPrefix(speedAuditVersion?: SpeedAuditVersion) {
  return `Speed Audit ${speedAuditVersion === SpeedAuditVersion.v2 ? '2' : ''}`;
}

export function getLatestResponseFromSubtaskAssignments(
  subtaskAssignments: PartialRecord<string, SubtaskAssignment>,
  subtaskId: string,
) {
  const responses = subtaskAssignments[subtaskId]?.responses;
  if (!responses || responses.length === 0) {
    return null;
  }
  return responses[0];
}
